import { installCrmErrorReporting } from './lib/crmErrors';

// Side-effect dependency: evaluate before the static native OAuth handoff module.
// Keep this independent of App/UserManager and native credential storage.
try { installCrmErrorReporting(); } catch { /* Optional telemetry cannot block auth bootstrap. */ }
